<template>
  <j-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel">
    <order-tms-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></order-tms-form>
  </j-modal>
</template>

<script>

  import OrderTmsForm from './OrderTmsForm'

  export default {
    name: 'OrderTmsModal',
    components: {
      OrderTmsForm
    },
    data() {
      return {
        title:'運單維護',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods:{
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        console.log("handle OK");
        this.$refs.realForm.submitForm(); 
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style scoped>
</style>